(function () {
  'use strict';

  function initBundleBuilder(root) {
    if (!root || root.dataset.mbBbReady === 'true') return;
    root.dataset.mbBbReady = 'true';

    var config;
    try {
      config = JSON.parse(root.querySelector('[data-mb-bb-config]').textContent);
    } catch (e) {
      console.warn('Bundle builder config failed to parse', e);
      return;
    }

    var tiers = (config.tiers || []).slice().sort(function (a, b) { return a.count - b.count; });
    var groups = (config.groups || []).filter(function (g) { return g.products && g.products.length; });
    var colorAccentPacksEnabled = config.colorAccentPacksEnabled === true;
    if (!groups.length) return;

    // Every current and future page using the shared bundle-builder section
    // writes the same relationship contract. Persisted legacy carts remain
    // readable, but new bundle groups never write the retired property set.
    var relationshipContract = window.MagBakCartRelationship;
    var relationshipWriterEnabled = Boolean(relationshipContract);
    root.dataset.mbBundleRelationshipWriter = relationshipWriterEnabled ? 'v1' : 'unavailable';

    function planBundleRelationships(bundlePicks) {
      if (!relationshipWriterEnabled) return null;
      try {
        return relationshipContract.planNewBundleRelationshipGroup(bundlePicks.map(function (pick) {
          var childKinds = [];
          if (pick.accent && pick.accent.variant) {
            childKinds.push(relationshipContract.KINDS.DEPENDENT);
          }
          if (pick.customization && pick.customization.variant) {
            childKinds.push(relationshipContract.KINDS.PERSONALIZATION);
          }
          return { childKinds: childKinds };
        }), { tiers: tiers });
      } catch (error) {
        root.dataset.mbBundleRelationshipWriter = 'error';
        console.error('Bundle relationship metadata could not be created.', error);
        return null;
      }
    }

    // theme-editor SKU exclusions: drop those variants up front so nothing
    // downstream (tiles, option cascade, pricing, variant matching) sees them
    var excludedSkus = {};
    Object.keys(config.excludedSkus || {}).forEach(function (pid) {
      var set = {};
      String(config.excludedSkus[pid]).split(',').forEach(function (sku) {
        sku = sku.trim().toLowerCase();
        if (sku) set[sku] = true;
      });
      excludedSkus[pid] = set;
    });
    groups.forEach(function (group) {
      group.products = group.products.filter(Boolean);
      group.products.forEach(function (product) {
        var excluded = excludedSkus[String(product.id)];
        if (!excluded) return;
        product.variants = product.variants.filter(function (v) {
          return !(v.sku && excluded[String(v.sku).trim().toLowerCase()]);
        });
        product.available = product.variants.some(function (v) { return v.available; });
        var priced = product.variants.filter(function (v) { return v.available; });
        if (!priced.length) priced = product.variants;
        if (priced.length) {
          product.price_min = priced.reduce(function (min, v) {
            return Math.min(min, v.price);
          }, Infinity);
        }
      });
    });

    /* ---------- money formatting ---------- */
    var moneyParts = (function (sample) {
      // sample renders 123456789 (cents), e.g. "$1,234,567.89" or "1.234.567,89 €"
      var m = sample.match(/1(\D?)234(\D?)567(\D*?)89/);
      if (!m) return { prefix: '$', thousands: ',', decimal: '.', decimals: 2, suffix: '' };
      var idx = sample.indexOf('1');
      var end = sample.lastIndexOf('89') + 2;
      return {
        prefix: sample.slice(0, idx),
        thousands: m[1] || ',',
        decimal: m[3] || '.',
        decimals: m[3] === '' ? 0 : 2,
        suffix: sample.slice(end)
      };
    })(config.moneySample || '$1,234,567.89');

    function money(cents) {
      var neg = cents < 0;
      cents = Math.abs(Math.round(cents));
      var units = moneyParts.decimals === 0 ? String(Math.round(cents / 100)) : String(Math.floor(cents / 100));
      var dec = String(cents % 100).padStart(2, '0');
      var grouped = units.replace(/\B(?=(\d{3})+(?!\d))/g, moneyParts.thousands);
      var out = moneyParts.prefix + grouped + (moneyParts.decimals ? moneyParts.decimal + dec : '') + moneyParts.suffix;
      return (neg ? '−' : '') + out;
    }

    /* ---------- helpers ---------- */
    var labelOverrides = config.labels || {};
    var tileImageOverrides = config.tileImages || {};
    var preferredCaseModel = normalizeCaseModel(document.documentElement.dataset.mbBundleModel);

    function shortTitle(title) {
      return String(title || '')
        .replace(/^MagBak (for )?/i, '')
        .split(/\s\+\s/)[0]
        .trim();
    }

    function displayName(product) {
      return labelOverrides[product.id] || shortTitle(product.title);
    }

    // full product name for the sheet, minus marketing suffixes
    // ("MagBak Elite for Galaxy S26 Series + MagSticks..." -> before the "+")
    function fullTitle(product) {
      return String(product.title || '').split(/\s\+\s/)[0].trim();
    }

    function hasRealOptions(product) {
      if (!product.variants || product.variants.length <= 1) return false;
      return true;
    }

    function defaultVariant(product) {
      for (var i = 0; i < product.variants.length; i++) {
        if (product.variants[i].available) return product.variants[i];
      }
      return product.variants[0];
    }

    function matchVariant(product, chosen) {
      return product.variants.find(function (v) {
        return product.options.every(function (opt, i) {
          return v.options[i] === chosen[opt.name];
        });
      }) || null;
    }

    function normalizeCaseModel(value) {
      value = String(value || '').toLowerCase();
      if (value.indexOf('classic') !== -1) return 'classic';
      if (value.indexOf('elite') !== -1) return 'elite';
      return '';
    }

    function caseModelOption(product) {
      if (!product || !product.options) return null;
      for (var i = 0; i < product.options.length; i++) {
        var opt = product.options[i];
        var values = opt.values || [];
        if (!values.length && product.variants) {
          values = product.variants.map(function (variant) { return variant.options[i]; })
            .filter(function (value, index, list) { return list.indexOf(value) === index; });
        }
        var hasModelValues = values.some(function (value) {
          return !!normalizeCaseModel(value);
        });
        if (!hasModelValues) continue;
        var name = String(opt.name || '').toLowerCase();
        if (name.indexOf('case model') !== -1 || name.indexOf('magbak model') !== -1 || name === 'model' || name.indexOf('style') !== -1 || name.indexOf('type') !== -1) {
          return { opt: opt, idx: i };
        }
      }
      return null;
    }

    function applyPreferredCaseModel(product, chosen) {
      var model = normalizeCaseModel(preferredCaseModel);
      if (!model || !product || !chosen) return false;
      var modelOption = caseModelOption(product);
      if (!modelOption) return false;
      var values = modelOption.opt.values || [];
      if (!values.length && product.variants) {
        values = product.variants.map(function (variant) { return variant.options[modelOption.idx]; })
          .filter(function (value, index, list) { return list.indexOf(value) === index; });
      }
      var match = values.find(function (value) {
        return normalizeCaseModel(value) === model;
      });
      if (!match || chosen[modelOption.opt.name] === match) return false;
      chosen[modelOption.opt.name] = match;
      return true;
    }

    function optionKind(product, opt) {
      // mirrors the PDP's option_layout rules
      var n = opt.name.toLowerCase();
      if (opt.art) return 'device';
      if (n.indexOf('color') !== -1 || n.indexOf('colour') !== -1 || n.indexOf('finish') !== -1) return 'swatch';
      if (n.indexOf('magbak model') !== -1 || n.indexOf('series') !== -1 || n.indexOf('type') !== -1 || n.indexOf('style') !== -1 || n.indexOf('model') !== -1) return 'series';
      return 'chip';
    }

    function mediaImageSrc(image) {
      if (!image) return null;
      if (typeof image === 'string') return image;
      return image.src
        || image.url
        || (image.preview_image && mediaImageSrc(image.preview_image))
        || (image.image && mediaImageSrc(image.image))
        || null;
    }

    function variantImage(variant) {
      return variant && (
        variant.image
        || variant.gallery_image
        || mediaImageSrc(variant.featured_image)
        || mediaImageSrc(variant.featured_media)
      ) || null;
    }

    function mediaPreviewSrc(media) {
      return mediaImageSrc(media && (media.preview_image || media.image || media.src || media.url));
    }

    function mediaAltSkus(alt) {
      if (!alt) return [];
      var parts = String(alt).split('|');
      if (parts.length < 2) return [];
      return parts.pop().split(',').map(function (part) { return part.trim(); }).filter(Boolean);
    }

    function mediaKey(media) {
      var alt = media && media.alt;
      if (!alt) return '';
      return String(alt).split('|')[0].trim().toLowerCase().replace(/\s+/g, ' ');
    }

    function mediaMatchesSku(media, sku, id) {
      return mediaMatchesAnySku(media, sku ? [sku] : [], id);
    }

    function mediaMatchesAnySku(media, skus, id) {
      skus = (skus || []).filter(Boolean);
      if (!skus.length) return true;
      var parts = mediaAltSkus(media && media.alt);
      if (!parts.length) return true;
      var negatives = parts.filter(function (part) { return part.charAt(0) === '!'; });
      if (negatives.length) {
        return !skus.some(function (sku) { return parts.indexOf('!' + sku) !== -1; });
      }
      return skus.some(function (sku) { return parts.indexOf(sku) !== -1; }) || parts.indexOf(String(id)) !== -1;
    }

    function mediaHasPositiveMatch(media, sku, id) {
      return mediaHasPositiveMatchAny(media, sku ? [sku] : [], id);
    }

    function mediaHasPositiveMatchAny(media, skus, id) {
      skus = (skus || []).filter(Boolean);
      if (!skus.length) return false;
      var parts = mediaAltSkus(media && media.alt).filter(function (part) { return part.charAt(0) !== '!'; });
      return skus.some(function (sku) { return parts.indexOf(sku) !== -1; }) || parts.indexOf(String(id)) !== -1;
    }

    function accentSkuAliases(variant) {
      var sku = String(variant && variant.sku || '').trim();
      if (!sku) return [];
      var aliases = [sku];
      var parts = sku.split('-').filter(Boolean);
      if (parts.indexOf('ACU') !== -1 && parts.length > 1) {
        aliases.push('ACU-' + parts[parts.length - 1]);
      }
      return aliases.filter(function (value, index, list) { return value && list.indexOf(value) === index; });
    }

    function addonMatchingMedia(accent, parentVariant) {
      var media = accent && accent.product && accent.product.media || [];
      if (!media.length || !accent.variant) return [];
      var variant = accent.variant;
      var variantSkus = accentSkuAliases(variant);
      var variantMatches = media.filter(function (item) {
        return mediaMatchesAnySku(item, variantSkus, variant.id);
      });
      var parentSpecific = variantMatches.filter(function (item) {
        return mediaHasPositiveMatch(item, parentVariant && parentVariant.sku, parentVariant && parentVariant.id);
      });
      if (parentSpecific.length) return parentSpecific;
      var variantSpecific = variantMatches.filter(function (item) {
        return mediaHasPositiveMatchAny(item, variantSkus, variant.id);
      });
      if (variantSpecific.length) return variantSpecific;
      return variantMatches.length ? variantMatches : media;
    }

    function replacementForMedia(baseMedia, replacements) {
      var key = mediaKey(baseMedia);
      if (!key) return null;
      var baseSkus = mediaAltSkus(baseMedia && baseMedia.alt).filter(function (sku) {
        return sku.charAt(0) !== '!';
      });
      var candidates = replacements.filter(function (media) { return mediaKey(media) === key; });
      if (!candidates.length) return null;
      if (!baseSkus.length) return candidates[0];
      return candidates.find(function (candidate) {
        var candidateSkus = mediaAltSkus(candidate && candidate.alt);
        return baseSkus.some(function (sku) { return candidateSkus.indexOf(sku) !== -1; });
      }) || null;
    }

    function preferredMediaFromList(media) {
      if (!media || !media.length) return null;
      return media.find(function (item) { return /sandwich|back to back/.test(mediaKey(item)); })
        || media.find(function (item) { return /accent|button|color/.test([mediaKey(item), item && item.alt].join(' ').toLowerCase()); })
        || media[0];
    }

    function preferredAccentMedia(product, variant, accent) {
      if (!product || !variant || !accent || !accent.variant) return null;
      var baseMedia = (product.media || []).filter(function (item) {
        return mediaMatchesSku(item, variant.sku, variant.id);
      });
      var replacements = addonMatchingMedia(accent, variant);
      var candidates = baseMedia.map(function (item) {
        var replacement = replacementForMedia(item, replacements);
        return replacement ? { media: replacement, key: mediaKey(item) || mediaKey(replacement) } : null;
      }).filter(Boolean);

      var picked = candidates.find(function (candidate) { return /sandwich|back to back/.test(candidate.key); })
        || candidates.find(function (candidate) { return /accent|button|color/.test(candidate.key); })
        || candidates[0];
      if (picked && mediaPreviewSrc(picked.media)) return picked.media;

      var baseFallback = preferredMediaFromList(baseMedia);
      if (baseFallback && mediaPreviewSrc(baseFallback)) return baseFallback;

      var fallback = preferredMediaFromList(replacements);
      return fallback && mediaPreviewSrc(fallback) ? fallback : null;
    }

    function imageForColorSelection(product, variant, chosen) {
      if (!product || !product.options) return null;
      var visualIndexes = [];
      product.options.forEach(function (opt, idx) {
        if (optionKind(product, opt) === 'swatch') visualIndexes.push(idx);
      });
      if (!visualIndexes.length) return null;

      for (var v = 0; v < visualIndexes.length; v++) {
        var colorIdx = visualIndexes[v];
        var opt = product.options[colorIdx];
        var selected = chosen && chosen[opt.name];
        if (!selected) continue;

        var best = null;
        var bestScore = -1;
        product.variants.forEach(function (candidate) {
          var src = variantImage(candidate);
          if (!src || candidate.options[colorIdx] !== selected) return;
          var score = candidate.available ? 2 : 1;
          product.options.forEach(function (otherOpt, otherIdx) {
            if (otherIdx === colorIdx || !chosen || chosen[otherOpt.name] == null) return;
            if (candidate.options[otherIdx] === chosen[otherOpt.name]) score += 1;
          });
          if (variant && candidate.id === variant.id) score += 10;
          if (score > bestScore) {
            bestScore = score;
            best = src;
          }
        });
        if (best) return best;
      }
      return null;
    }

    function modalImageSrc(product, variant, chosen, accent) {
      var accentMedia = preferredAccentMedia(product, variant, accent);
      return mediaPreviewSrc(accentMedia)
        || variantImage(variant)
        || imageForColorSelection(product, variant, chosen)
        || variantImage(accent && accent.variant)
        || product.featured_image;
    }

    function seriesDescription(product, value) {
      // same hardcoded mapping the PDP uses for series cards
      var v = value.toLowerCase();
      if (/wallet/.test(product.handle || '')) {
        if (v.indexOf('tracking') !== -1) return 'Apple FindMy & Google Find Hub Compatible';
        if (v.indexOf('classic') !== -1) return 'Minimal, Functional, and Practical';
      }
      if (v.indexOf('elite') !== -1) return 'Feature rich and customizable!';
      if (v.indexOf('classic') !== -1) return 'Minimalist and timeless!';
      if (v.indexOf('clear') !== -1) return 'Show your phone! Yellow-resistant.';
      if (v.indexOf('pro') !== -1) return 'Premium magnetic protection';
      return 'Compatible MagBak configuration';
    }

    function valuesFor(product, optIdx, chosen) {
      // values that exist among variants matching the chosen earlier options
      var seen = [];
      var out = [];
      product.variants.forEach(function (v) {
        for (var j = 0; j < optIdx; j++) {
          if (v.options[j] !== chosen[product.options[j].name]) return;
        }
        var val = v.options[optIdx];
        var at = seen.indexOf(val);
        if (at === -1) {
          seen.push(val);
          out.push({ value: val, available: v.available });
        } else if (v.available) {
          out[at].available = true;
        }
      });
      return out;
    }

    function priceFor(product, optIdx, value, chosen) {
      var best = null;
      product.variants.forEach(function (v) {
        for (var j = 0; j < optIdx; j++) {
          if (v.options[j] !== chosen[product.options[j].name]) return;
        }
        if (v.options[optIdx] !== value) return;
        if (best === null || v.price < best) best = v.price;
      });
      return best;
    }

    function normalizeChosen(product, chosen) {
      product.options.forEach(function (opt, i) {
        var candidates = valuesFor(product, i, chosen);
        var stillValid = candidates.some(function (c) { return c.value === chosen[opt.name]; });
        if (!stillValid && candidates.length) {
          var pick = candidates.find(function (c) { return c.available; }) || candidates[0];
          chosen[opt.name] = pick.value;
        }
      });
    }

    function swatchFor(product, optName, value) {
      // mb-jsonify-swatches emits { OptionName: { Value: { color, image } } }
      var byOption = product.swatches && product.swatches[optName];
      if (!byOption) return null;
      var entry = byOption[value];
      if (!entry) {
        var key = Object.keys(byOption).find(function (k) { return k.toLowerCase() === value.toLowerCase(); });
        entry = key ? byOption[key] : null;
      }
      if (!entry) return null;
      var image = entry.image;
      if (image && typeof image === 'object') image = image.src || (image.preview_image && image.preview_image.src) || null;
      return { color: entry.color || null, image: image || null };
    }

    function fallbackSwatchColor(value) {
      var v = String(value || '').toLowerCase();
      if (v.indexOf('black') !== -1 || v.indexOf('midnight') !== -1) return '#111416';
      if (v.indexOf('white') !== -1 || v.indexOf('stone') !== -1) return '#f4f5f6';
      if (v.indexOf('clear') !== -1) return '#faf9ef';
      if (v.indexOf('brown') !== -1) return '#7a4d34';
      if (v.indexOf('tan') !== -1) return '#c8a77e';
      if (v.indexOf('beige') !== -1 || v.indexOf('sand') !== -1) return '#e6dcc7';
      if (v.indexOf('gold') !== -1) return '#d7bf84';
      if (v.indexOf('red') !== -1) return '#F61F1F';
      if (v.indexOf('blue') !== -1) return '#508bc1';
      if (v.indexOf('lime') !== -1) return '#88EF01';
      if (v.indexOf('lemon') !== -1 || v.indexOf('yellow') !== -1) return '#f5df4d';
      if (v.indexOf('olive') !== -1) return '#228b22';
      if (v.indexOf('green') !== -1) return '#228b22';
      if (v.indexOf('orange') !== -1) return '#FF8A00';
      if (v.indexOf('pink') !== -1) return '#f5a8bd';
      if (v.indexOf('purple') !== -1) return '#7054a8';
      if (v.indexOf('gray') !== -1 || v.indexOf('grey') !== -1) return '#e2e2e2';
      return '#d8dadd';
    }

    function applySwatchStyle(btn, swatch, value) {
      if (swatch && swatch.image) {
        btn.style.cssText = 'background-image:url(' + swatch.image + ');background-size:cover;background-position:center';
        return;
      }
      btn.style.cssText = 'background:' + ((swatch && swatch.color) || fallbackSwatchColor(value));
    }

    function setProductSwatches(product, swatches) {
      if (product && !product.swatches && swatches) product.swatches = swatches;
      return product;
    }

    function addonIdentity(addon) {
      return [
        addon && addon.tagline,
        addon && addon.product && addon.product.title,
        addon && addon.product && addon.product.handle,
        addon && addon.product && addon.product.type
      ].filter(Boolean).join(' ').toLowerCase();
    }

    function colorAccentAddon(product) {
      if (!colorAccentPacksEnabled || !product) return null;
      var addons = []
        .concat(product.inline_bundles || [])
        .concat(product.inline_upsells || []);
      var matches = addons.filter(function (entry) {
        var identity = addonIdentity(entry);
        return /color|colour|accent/.test(identity)
          && !/camera|button/.test(identity);
      });
      var addon = matches[0];
      if (!addon || !addon.product || !addon.product.variants) return null;
      setProductSwatches(addon.product, addon.swatches);
      var seenMedia = {};
      addon.product.media = matches.reduce(function (media, entry) {
        var productMedia = entry && entry.product && entry.product.media || [];
        productMedia.forEach(function (item) {
          var key = [item.id, item.alt, mediaPreviewSrc(item)].filter(Boolean).join('|');
          if (seenMedia[key]) return;
          seenMedia[key] = true;
          media.push(item);
        });
        return media;
      }, []);
      return addon;
    }

    function addonVariantMeta(addon, variant) {
      return addon && addon.variant_metafields && variant
        ? addon.variant_metafields[String(variant.id)] || {}
        : {};
    }

    function addonCartProperties(addon, variant) {
      var props = addonVariantMeta(addon, variant).cart_properties;
      return Array.isArray(props) ? props.filter(function (prop) { return prop && prop.key; }) : [];
    }

    function customizationAddon(product) {
      if (!product) return null;
      var addons = []
        .concat(product.inline_bundles || [])
        .concat(product.inline_upsells || []);
      return addons.find(function (addon) {
        if (!addon || !addon.product || !addon.product.variants) return false;
        var identity = addonIdentity(addon);
        if (!/(personal|custom|engrave|engraving|monogram)/.test(identity)) return false;
        if (/gift|wrap/.test(identity)) return false;
        return addon.product.variants.some(function (variant) {
          return variant && variant.available && !variantHidden(addon, variant) && addonCartProperties(addon, variant).length;
        });
      }) || null;
    }

    function optionMatchWords(variant) {
      return normalizedWords([
        variant && variant.title,
        variant && (variant.options || []).join(' ')
      ].filter(Boolean).join(' ')).filter(function (word) {
        return !/^(default|title|for|series|magbak|wallet|case|apple|android|iphone|ipad|samsung|galaxy|airpods|airpod|pro|gen|with|and)$/.test(word);
      });
    }

    function variantOptionMatchScore(addonVariant, mainVariant) {
      var addonText = variantSearchText(addonVariant).replace(/[^a-z0-9]+/g, ' ');
      return optionMatchWords(mainVariant).reduce(function (score, word) {
        return score + (addonText.indexOf(word) !== -1 ? 1 : 0);
      }, 0);
    }

    function customizationCandidates(addon, mainProduct, mainVariant) {
      if (!addon || !addon.product || !mainVariant) return [];
      var addonProduct = addon.product;
      var device = deviceValueFor(mainProduct, mainVariant);
      var available = (addonProduct.variants || []).filter(function (variant) {
        return variant && variant.available && !variantHidden(addon, variant) && addonCartProperties(addon, variant).length;
      });
      if (!available.length) return [];
      var deviceMatched = available.filter(function (variant) {
        return variantMatchesDevice(variant, device);
      });
      var candidates = deviceMatched.length ? deviceMatched : available;
      var bestScore = candidates.reduce(function (score, variant) {
        return Math.max(score, variantOptionMatchScore(variant, mainVariant));
      }, 0);
      return bestScore > 0
        ? candidates.filter(function (variant) { return variantOptionMatchScore(variant, mainVariant) === bestScore; })
        : candidates;
    }

    function customizationTitle(addon, parentProduct) {
      var identity = [
        parentProduct && parentProduct.title,
        parentProduct && parentProduct.handle,
        addonIdentity(addon)
      ].filter(Boolean).join(' ').toLowerCase();
      if (identity.indexOf('wallet') !== -1) return 'Personalize Your Wallet';
      if (identity.indexOf('airpods') !== -1) return 'Personalize Your AirPods Case';
      return addon && (addon.tagline || (addon.product && addon.product.title)) || 'Personalize';
    }

    function normalizeCartPropertyAttributes(attributes) {
      return attributes && typeof attributes === 'object' && !Array.isArray(attributes) ? attributes : {};
    }

    function cartPropertyAttributesHTML(attributes) {
      var normalized = normalizeCartPropertyAttributes(attributes);
      var blocked = { class: true, cls: true, key: true, name: true, value: true };
      return Object.keys(normalized).map(function (key) {
        var value = normalized[key];
        if (blocked[key] || value === false || value === null || value === undefined) return '';
        if (value === true) return ' ' + escapeHtml(key);
        return ' ' + escapeHtml(key) + '="' + escapeHtml(value) + '"';
      }).join('');
    }

    function customizationInputValue(prop, values) {
      return values && prop && prop.key ? values[prop.key] || '' : '';
    }

    function formatCustomizationValue(prop, rawValue) {
      var value = String(rawValue || '').trim();
      if (!value) return '';
      return String(prop.css_classes || '').indexOf('uppercase') !== -1 ? value.toUpperCase() : value;
    }

    function customizationSummary(properties, values) {
      return (properties || []).map(function (prop) {
        var value = formatCustomizationValue(prop, customizationInputValue(prop, values));
        if (!value) return '';
        var label = prop.name || prop.key;
        return label ? label + ': ' + value : value;
      }).filter(Boolean).join(' / ');
    }

    function customizationSelectionKey(customization) {
      if (!customization || !customization.variant) return '';
      var keys = Object.keys(customization.properties || {}).sort();
      return [
        customization.variant.id,
        keys.map(function (key) { return key + '=' + customization.properties[key]; }).join('&')
      ].join('|');
    }

    function isEliteVariant(variant) {
      if (!variant) return false;
      var sku = String(variant.sku || '').trim().toUpperCase();
      if (sku.charAt(0) === 'E') return true;
      return [
        variant.title,
        (variant.options || []).join(' ')
      ].filter(Boolean).join(' ').toLowerCase().indexOf('elite') !== -1;
    }

    function normalizedWords(value) {
      return String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim().split(/\s+/).filter(Boolean);
    }

    function deviceValueFor(product, variant) {
      if (!product || !variant) return '';
      var idx = product.options.findIndex(function (opt) {
        var name = String(opt.name || '').toLowerCase();
        return name.indexOf('device') !== -1 || name.indexOf('model') !== -1 || name.indexOf('iphone') !== -1 || name.indexOf('galaxy') !== -1;
      });
      return idx >= 0 ? variant.options[idx] : '';
    }

    function variantSearchText(variant) {
      return [
        variant && variant.title,
        variant && variant.sku,
        variant && (variant.options || []).join(' ')
      ].filter(Boolean).join(' ').toLowerCase();
    }

    function variantMatchesDevice(variant, deviceValue) {
      var words = normalizedWords(deviceValue).filter(function (word) {
        return !/^(for|series|galaxy|samsung|iphone|apple)$/.test(word);
      });
      if (!words.length) return true;
      var text = variantSearchText(variant).replace(/[^a-z0-9]+/g, ' ');
      return words.every(function (word) { return text.indexOf(word) !== -1; });
    }

    function addonOptionNames(addonProduct) {
      return (addonProduct.options || []).map(function (opt) {
        return typeof opt === 'string' ? opt : opt.name;
      });
    }

    function colorOptionIndex(addonProduct, deviceValue) {
      var names = addonOptionNames(addonProduct);
      var idx = names.findIndex(function (name) {
        return /color|colour|finish|accent|button/.test(String(name || '').toLowerCase());
      });
      if (idx >= 0) return idx;
      var deviceWords = normalizedWords(deviceValue);
      for (var i = names.length - 1; i >= 0; i--) {
        var values = (addonProduct.variants || []).map(function (v) { return v.options && v.options[i]; }).filter(Boolean);
        var looksDevice = values.some(function (value) {
          var valueWords = normalizedWords(value);
          return deviceWords.length && deviceWords.every(function (word) { return valueWords.indexOf(word) !== -1; });
        });
        if (!looksDevice) return i;
      }
      return names.length ? names.length - 1 : 0;
    }

    function variantHidden(addon, variant) {
      var meta = addon && addon.variant_metafields && addon.variant_metafields[String(variant.id)];
      return meta && meta.force_hide === true;
    }

    function discountedAddonPrice(addon, variant) {
      var price = Number(variant && variant.price || 0);
      var amount = Number(addon && addon.discount_amount || 0);
      if (amount <= 0) return price;
      if (addon.discount_type === 'Percent') {
        return Math.round(price * (1 - Math.min(amount, 100) / 100));
      }
      return Math.max(0, price - amount);
    }

    function addonPriceHTML(price, regularPrice) {
      if (price == null) return '';
      var html = '<span>+' + money(price) + '</span>';
      if (regularPrice && regularPrice > price) {
        html += '<s>+' + money(regularPrice) + '</s>';
      }
      return html;
    }

    function accentCandidates(addon, mainProduct, mainVariant) {
      if (!addon || !addon.product || !mainVariant || !isEliteVariant(mainVariant)) return [];
      var addonProduct = addon.product;
      var device = deviceValueFor(mainProduct, mainVariant);
      var available = (addonProduct.variants || []).filter(function (variant) {
        return variant && variant.available && !variantHidden(addon, variant);
      });
      var deviceMatched = available.filter(function (variant) {
        return variantMatchesDevice(variant, device);
      });
      var candidates = deviceMatched.length ? deviceMatched : available;
      var colorIdx = colorOptionIndex(addonProduct, device);
      var seen = {};
      return candidates.reduce(function (out, variant) {
        var color = (variant.options && variant.options[colorIdx]) || variant.title || 'Color';
        var key = String(color).toLowerCase();
        if (seen[key]) return out;
        seen[key] = true;
        out.push({
          variant: variant,
          color: color,
          optionName: addonOptionNames(addonProduct)[colorIdx] || 'Color',
          price: discountedAddonPrice(addon, variant),
          regularPrice: Number(variant.price || 0),
          discountType: addon.discount_type || '',
          discountAmount: Number(addon.discount_amount || 0)
        });
        return out;
      }, []);
    }

    function accentPickPrice(pick) {
      return pick && pick.accent && pick.accent.variant ? Number(pick.accent.price || pick.accent.variant.price || 0) * pick.qty : 0;
    }

    function customizationPickPrice(pick) {
      return pick && pick.customization && pick.customization.variant
        ? Number(pick.customization.price || pick.customization.variant.price || 0) * pick.qty
        : 0;
    }

    function pickLinePrice(pick) {
      return (pick.variant.price * pick.qty) + accentPickPrice(pick) + customizationPickPrice(pick);
    }

    function el(tag, cls, html) {
      var node = document.createElement(tag);
      if (cls) node.className = cls;
      if (html !== undefined) node.innerHTML = html;
      return node;
    }

    function escapeHtml(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    /* ---------- state ---------- */
    var picks = [];
    var uidSeq = 0;
    var productIndex = {};
    groups.forEach(function (g) {
      g.products.forEach(function (p) { if (p) productIndex[p.id] = p; });
    });

    var els = {
      groups: root.querySelector('[data-mb-bb-groups]'),
      tierTiles: root.querySelectorAll('[data-mb-bb-tier]'),
      summary: root.querySelector('[data-mb-bb-summary]'),
      lines: root.querySelector('[data-mb-bb-lines]'),
      subtotal: root.querySelector('[data-mb-bb-subtotal]'),
      discountRow: root.querySelector('[data-mb-bb-discount-row]'),
      discountLabel: root.querySelector('[data-mb-bb-discount-label]'),
      discount: root.querySelector('[data-mb-bb-discount]'),
      total: root.querySelector('[data-mb-bb-total]'),
      note: root.querySelector('[data-mb-bb-note]'),
      atc: root.querySelector('[data-mb-bb-atc]'),
      atcLabel: root.querySelector('[data-mb-bb-atc-label]'),
      error: root.querySelector('[data-mb-bb-error]'),
      gallery: root.querySelector('.mb-bb__gallery-main > img'),
      galleryVideo: root.querySelector('[data-mb-bb-main-video]'),
      sheet: root.querySelector('[data-mb-bb-sheet]'),
      sheetBody: root.querySelector('[data-mb-bb-sheet-body]'),
      sticky: root.querySelector('[data-mb-bb-sticky]'),
      stickyCount: root.querySelector('[data-mb-bb-sticky-count]'),
      stickyLabel: root.querySelector('[data-mb-bb-sticky-label]'),
      stickyTotal: root.querySelector('[data-mb-bb-sticky-total]'),
      stickyCompare: root.querySelector('[data-mb-bb-sticky-compare]'),
      stickySave: root.querySelector('[data-mb-bb-sticky-save]'),
      stickyAtc: root.querySelector('[data-mb-bb-sticky-atc]')
    };
    var galleryOriginal = els.gallery ? els.gallery.src : null;

    /* ---------- tier math ---------- */
    function totalQty() {
      return picks.reduce(function (n, p) { return n + p.qty; }, 0);
    }

    function activeTier(count) {
      var t = null;
      tiers.forEach(function (tier) { if (count >= tier.count) t = tier; });
      return t;
    }

    function nextTier(count) {
      return tiers.find(function (tier) { return count < tier.count; }) || null;
    }

    /* ---------- rendering: groups & tiles ---------- */
    function renderGroups() {
      groups.forEach(function (group) {
        var wrap = el('div', 'mb-bb__group');
        wrap.dataset.groupId = group.id;

        var head = el('header', 'mb-bb__group-head');
        head.appendChild(el('h3', 'mb-bb__group-title', escapeHtml(group.title)));
        var state = el('span', 'mb-bb__group-state');
        state.dataset.mbBbGroupState = group.id;
        head.appendChild(state);
        wrap.appendChild(head);

        var tiles = el('div', 'mb-bb__tiles');
        var products = group.products.filter(Boolean);
        products.forEach(function (product) {
          var tile = el('button', 'mb-bb__tile');
          tile.type = 'button';
          // tiles show the product photo (or a per-product override image);
          // device line-art lives only in the configure modal now
          var img = tileImageOverrides[product.id] || product.featured_image;
          var fromPrefix = product.variants.length > 1 ? 'From ' : '';
          tile.innerHTML =
            '<span class="mb-bb__tile-media">' +
            (img ? '<img src="' + escapeHtml(img) + '" alt="" loading="lazy">' : '') +
            '</span>' +
            '<span class="mb-bb__tile-name">' + escapeHtml(displayName(product)) + '</span>' +
            '<span class="mb-bb__tile-price">' + fromPrefix + money(product.price_min) + '</span>' +
            '<span class="mb-bb__tile-badge" data-tile-badge hidden></span>';
          tile.dataset.productId = product.id;
          if (!product.available) {
            tile.disabled = true;
            tile.classList.add('is-soldout');
          }
          tile.addEventListener('click', function () { onTileClick(group, product); });
          tiles.appendChild(tile);
        });
        wrap.appendChild(tiles);

        var picksList = el('ul', 'mb-bb__picks');
        picksList.dataset.mbBbPicks = group.id;
        wrap.appendChild(picksList);

        els.groups.appendChild(wrap);
      });
    }


    function groupCount(group) {
      return picks.filter(function (p) { return p.groupId === group.id; })
        .reduce(function (n, p) { return n + p.qty; }, 0);
    }

    function onTileClick(group, product) {
      // toggle: clicking a product that's already picked removes it (instead of
      // adding another / re-opening the configurator)
      var existing = picks.filter(function (p) {
        return p.groupId === group.id && p.product.id === product.id;
      });
      if (existing.length) {
        existing.forEach(function (p) { removePick(p.uid); });
        return;
      }
      if (group.max > 0 && groupCount(group) >= group.max) {
        flashError('You can pick up to ' + group.max + ' from this group. Remove one first.');
        return;
      }
      if (hasRealOptions(product)) {
        openSheet(group, product);
      } else {
        addPick(group, product, defaultVariant(product), 1);
      }
    }

    /* ---------- sheet (modal / bottom sheet) ---------- */
    var sheetState = null;
    var lastFocus = null;

    var sheetOpts = [];

    function openSheet(group, product) {
      var chosen = {};
      var dv = defaultVariant(product);
      product.options.forEach(function (opt, i) { chosen[opt.name] = dv.options[i]; });
      applyPreferredCaseModel(product, chosen);
      normalizeChosen(product, chosen);
      sheetState = {
        group: group,
        product: product,
        chosen: chosen,
        qty: 1,
        accent: null,
        accentKey: null,
        customization: null,
        customizationAddon: null,
        customizationKey: null,
        customizationSelected: false,
        customizationValues: {}
      };
      buildSheet();
      lastFocus = document.activeElement;
      els.sheet.hidden = false;
      document.documentElement.classList.add('mb-bb-lock');
      requestAnimationFrame(function () { els.sheet.classList.add('is-open'); });
      els.sheet.querySelector('.mb-bb-sheet__panel').focus({ preventScroll: true });
    }

    function closeSheet() {
      els.sheet.classList.remove('is-open');
      document.documentElement.classList.remove('mb-bb-lock');
      setTimeout(function () { els.sheet.hidden = true; }, 200);
      sheetState = null;
      sheetOpts = [];
      if (lastFocus) lastFocus.focus({ preventScroll: true });
    }

    document.addEventListener('mb:bundle-model-change', function (event) {
      preferredCaseModel = normalizeCaseModel(event && event.detail && event.detail.model);
      if (preferredCaseModel) root.dataset.preferredCaseModel = preferredCaseModel;
      if (!sheetState) return;
      if (applyPreferredCaseModel(sheetState.product, sheetState.chosen)) {
        normalizeChosen(sheetState.product, sheetState.chosen);
        syncSheet();
      }
    });

    function buildSheet() {
      var s = sheetState;
      if (!s) return;
      var product = s.product;
      var body = els.sheetBody;
      body.innerHTML = '';
      sheetOpts = [];

      var head = el('div', 'mb-bb-sheet__head');
      head.innerHTML =
        '<img class="mb-bb-sheet__img" data-sheet-img alt="">' +
        '<div><h3 class="mb-bb-sheet__title">' + escapeHtml(fullTitle(product)) + '</h3>' +
        '<p class="mb-bb-sheet__price" data-sheet-price></p></div>';
      body.appendChild(head);

      product.options.forEach(function (opt, optIdx) {
        if (opt.name === 'Title') return;
        var kind = optionKind(product, opt);
        var block = el('div', 'mb-bb-sheet__opt');
        var label = el('p', 'mb-bb-sheet__opt-label',
          escapeHtml(opt.name) + ' <strong data-opt-current></strong>');
        block.appendChild(label);
        var values = el('div', 'mb-bb-sheet__values mb-bb-sheet__values--' + kind);
        block.appendChild(values);
        body.appendChild(block);
        sheetOpts.push({
          opt: opt,
          idx: optIdx,
          kind: kind,
          valuesEl: values,
          currentEl: label.querySelector('[data-opt-current]'),
          key: null
        });
      });

      s.accentAddon = colorAccentAddon(product);
      if (s.accentAddon) {
        var accent = el('div', 'mb-bb-sheet__accent');
        accent.hidden = true;
        accent.innerHTML =
          '<div class="mb-bb-sheet__accent-head">' +
          '<div><p>Add a color accent <em data-accent-current></em></p><span>Optional swappable color pack</span></div>' +
          '<strong class="mb-bb-sheet__addon-price" data-accent-price></strong>' +
          '</div>' +
          '<div class="mb-bb-sheet__accent-values" data-accent-values></div>';
        body.appendChild(accent);
        s.accentEl = accent;
        s.accentValuesEl = accent.querySelector('[data-accent-values]');
        s.accentPriceEl = accent.querySelector('[data-accent-price]');
        s.accentCurrentEl = accent.querySelector('[data-accent-current]');
      }

      s.customizationAddon = customizationAddon(product);
      if (s.customizationAddon) {
        var customization = el('div', 'mb-bb-sheet__customization');
        customization.hidden = true;
        customization.innerHTML =
          '<button type="button" class="mb-bb-sheet__customization-head" data-customization-toggle aria-pressed="false">' +
          '<span class="mb-bb-sheet__customization-check" aria-hidden="true"></span>' +
          '<span><span data-customization-title>Personalize</span><em data-customization-summary></em></span>' +
          '<strong class="mb-bb-sheet__addon-price" data-customization-price></strong>' +
          '</button>' +
          '<div class="mb-bb-sheet__customization-fields" data-customization-fields></div>';
        body.appendChild(customization);
        s.customizationEl = customization;
        s.customizationToggleEl = customization.querySelector('[data-customization-toggle]');
        s.customizationTitleEl = customization.querySelector('[data-customization-title]');
        s.customizationSummaryEl = customization.querySelector('[data-customization-summary]');
        s.customizationPriceEl = customization.querySelector('[data-customization-price]');
        s.customizationFieldsEl = customization.querySelector('[data-customization-fields]');
        s.customizationToggleEl.addEventListener('click', function () {
          s.customizationSelected = !s.customizationSelected;
          syncSheet();
          if (s.customizationSelected) {
            var input = s.customizationFieldsEl && s.customizationFieldsEl.querySelector('[data-customization-property]');
            if (input) input.focus({ preventScroll: true });
          }
        });
      }

      var ship = el('p', 'mb-clean-ship-badge mb-bb-sheet__ship');
      ship.setAttribute('data-sheet-ship', '');
      ship.setAttribute('data-tone', 'standard');
      ship.hidden = true;
      body.appendChild(ship);

      var foot = el('div', 'mb-bb-sheet__foot');
      foot.innerHTML =
        '<div class="mb-bb-sheet__qty">' +
        '<button type="button" data-sheet-minus aria-label="Decrease">&minus;</button>' +
        '<span data-sheet-qty>1</span>' +
        '<button type="button" data-sheet-plus aria-label="Increase">+</button>' +
        '</div>' +
        '<button type="button" class="mb-bb-sheet__add" data-sheet-add>Add to bundle</button>';
      body.appendChild(foot);

      foot.querySelector('[data-sheet-minus]').addEventListener('click', function () {
        if (s.qty > 1) { s.qty--; syncSheet(); }
      });
      foot.querySelector('[data-sheet-plus]').addEventListener('click', function () {
        s.qty++; syncSheet();
      });
      foot.querySelector('[data-sheet-add]').addEventListener('click', function () {
        var variant = matchVariant(s.product, s.chosen);
        var customization = collectCustomizationSelection();
        if (customization === false) return;
        addPick(s.group, s.product, variant, s.qty, s.accent, customization);
        closeSheet();
      });

      syncSheet();
    }

    function renderOptionValues(entry, candidates) {
      var s = sheetState;
      var product = s.product;
      var opt = entry.opt;
      entry.valuesEl.innerHTML = '';

      candidates.forEach(function (candidate, candidateIdx) {
        var value = candidate.value;
        var btn = el('button');
        btn.type = 'button';
        btn.dataset.value = value;

        if (entry.kind === 'device') {
          btn.className = 'mb-bb-sheet__device';
          var art = opt.art && opt.art[value];
          btn.innerHTML =
            (art ? '<img src="' + escapeHtml(art) + '" alt="" loading="lazy">' : '') +
            '<span>' + escapeHtml(value) + '</span>';
        } else if (entry.kind === 'swatch') {
          btn.className = 'mb-bb-sheet__swatch';
          var sw = swatchFor(product, opt.name, value);
          applySwatchStyle(btn, sw, value);
          btn.title = value;
          btn.setAttribute('aria-label', value);
        } else if (entry.kind === 'series') {
          btn.className = 'mb-bb-sheet__series';
          var seriesPrice = priceFor(product, entry.idx, value, s.chosen);
          btn.innerHTML =
            (candidateIdx === 0 && candidates.length > 1 ? '<em>Bestseller</em>' : '') +
            '<b>' + escapeHtml(value) + '</b>' +
            '<small>' + escapeHtml(seriesDescription(product, value)) + '</small>' +
            (seriesPrice !== null ? '<strong>' + money(seriesPrice) + '</strong>' : '');
        } else {
          btn.className = 'mb-bb-sheet__chip';
          btn.textContent = value;
        }

        btn.addEventListener('click', function () {
          s.chosen[opt.name] = value;
          normalizeChosen(product, s.chosen);
          syncSheet();
        });
        entry.valuesEl.appendChild(btn);
      });
    }

    function renderAccentOptions(candidates) {
      var s = sheetState;
      if (!s || !s.accentValuesEl || !s.accentAddon) return;
      var addonProduct = s.accentAddon.product;
      s.accentValuesEl.innerHTML = '';

      candidates.forEach(function (candidate) {
        var variant = candidate.variant;
        var btn = el('button', 'mb-bb-sheet__accent-swatch');
        var sw = swatchFor(addonProduct, candidate.optionName, candidate.color);
        btn.type = 'button';
        btn.dataset.variantId = String(variant.id);
        btn.title = candidate.color;
        btn.setAttribute('aria-label', 'Add ' + candidate.color + ' color accent');
        applySwatchStyle(btn, sw, candidate.color);
        btn.addEventListener('click', function () {
          if (s.accent && String(s.accent.variant.id) === String(variant.id)) {
            s.accent = null;
          } else {
            s.accent = {
              product: addonProduct,
              variant: variant,
              color: candidate.color,
              price: candidate.price,
              regularPrice: candidate.regularPrice,
              discountType: candidate.discountType,
              discountAmount: candidate.discountAmount
            };
          }
          syncSheet();
        });
        s.accentValuesEl.appendChild(btn);
      });
    }

    function renderCustomizationFields(properties) {
      var s = sheetState;
      if (!s || !s.customizationFieldsEl) return;
      s.customizationFieldsEl.innerHTML = '';
      properties.forEach(function (property, propertyIndex) {
        var inputId = 'mb-bb-customization-' + (root.id || 'section') + '-' + propertyIndex;
        var label = property.name || property.key;
        var attrs = Object.assign({
          type: 'text',
          autocomplete: 'off'
        }, normalizeCartPropertyAttributes(property.attributes));
        var field = el('label', 'mb-bb-sheet__customization-field');
        field.innerHTML =
          '<span>' + escapeHtml(label) + '</span>' +
          '<input id="' + escapeHtml(inputId) + '"' +
          ' class="' + escapeHtml(property.css_classes || '') + '"' +
          ' aria-label="' + escapeHtml(label) + '"' +
          ' value="' + escapeHtml(customizationInputValue(property, s.customizationValues)) + '"' +
          ' data-customization-property' +
          ' data-property-key="' + escapeHtml(property.key) + '"' +
          cartPropertyAttributesHTML(attrs) +
          '>';
        var input = field.querySelector('[data-customization-property]');
        input.addEventListener('click', function (event) {
          event.stopPropagation();
        });
        input.addEventListener('input', function () {
          s.customizationValues[property.key] = input.value;
          if (String(input.value || '').trim()) s.customizationSelected = true;
          syncSheet();
        });
        s.customizationFieldsEl.appendChild(field);
      });
    }

    function syncCustomization(product, variant) {
      var s = sheetState;
      if (!s || !s.customizationEl || !s.customizationAddon) return 0;
      var candidates = variant && variant.available ? customizationCandidates(s.customizationAddon, product, variant) : [];
      var customizationVariant = candidates[0] || null;
      var properties = customizationVariant ? addonCartProperties(s.customizationAddon, customizationVariant) : [];
      var key = customizationVariant
        ? [customizationVariant.id, properties.map(function (property) { return property.key; }).join('|')].join(':')
        : '';

      s.customizationEl.hidden = !customizationVariant;
      s.customization = customizationVariant ? {
        addon: s.customizationAddon,
        product: s.customizationAddon.product,
        variant: customizationVariant,
        properties: properties,
        title: customizationTitle(s.customizationAddon, product),
        price: discountedAddonPrice(s.customizationAddon, customizationVariant),
        regularPrice: Number(customizationVariant.price || 0)
      } : null;

      if (!customizationVariant) {
        s.customizationSelected = false;
        s.customizationKey = null;
        return 0;
      }

      if (key !== s.customizationKey) {
        s.customizationKey = key;
        renderCustomizationFields(properties);
      }

      var summary = customizationSummary(properties, s.customizationValues);
      if (s.customizationTitleEl) s.customizationTitleEl.textContent = s.customization.title;
      if (s.customizationSummaryEl) {
        s.customizationSummaryEl.textContent = s.customizationSelected && summary ? summary : 'Optional personalization';
      }
      if (s.customizationPriceEl) {
        s.customizationPriceEl.innerHTML = addonPriceHTML(s.customization.price, s.customization.regularPrice);
      }
      if (s.customizationToggleEl) {
        s.customizationToggleEl.classList.toggle('is-selected', s.customizationSelected);
        s.customizationToggleEl.setAttribute('aria-pressed', String(s.customizationSelected));
      }
      return s.customizationSelected ? Number(s.customization.price || 0) : 0;
    }

    function collectCustomizationSelection() {
      var s = sheetState;
      if (!s || !s.customization || !s.customizationSelected) return null;
      var values = {};
      var valid = true;
      (s.customizationFieldsEl ? s.customizationFieldsEl.querySelectorAll('[data-customization-property]') : []).forEach(function (input) {
        if (input.hasAttribute('required') && !input.reportValidity()) valid = false;
        var rawValue = String(input.value || '').trim();
        if (!rawValue) return;
        values[input.dataset.propertyKey] = input.classList.contains('uppercase') ? rawValue.toUpperCase() : rawValue;
      });
      if (!valid) return false;
      return {
        product: s.customization.product,
        variant: s.customization.variant,
        title: s.customization.title,
        price: s.customization.price,
        regularPrice: s.customization.regularPrice,
        properties: values,
        summary: customizationSummary(s.customization.properties, values)
      };
    }

    // Mirror the PDP ship-message parse: "text | tone". A trailing "low" marker
    // is the green/in-stock state (e.g. "Ships next business day | low"); we do
    // NOT surface that in the modal. Anything else is the amber "standard" tone,
    // which signals a real shipping delay (e.g. "Ships late June") — show that.
    function shipDelay(variant, product) {
      var raw = String((variant && variant.ships) || (product && product.ships) || '').trim();
      if (!raw) return null;
      var parts = raw.split('|').map(function (p) { return p.trim(); }).filter(Boolean);
      if (!parts.length) return null;
      var isGreen = String(parts[parts.length - 1] || '').toLowerCase() === 'low';
      if (isGreen) return null;
      var text = parts.join(' | ').trim();
      return text || null;
    }

    function syncSheet() {
      var s = sheetState;
      if (!s) return;
      var product = s.product;
      var panel = els.sheet.querySelector('.mb-bb-sheet__panel');
      var keepScroll = panel.scrollTop;

      sheetOpts.forEach(function (entry) {
        var candidates = valuesFor(product, entry.idx, s.chosen);
        // rebuild this option's controls only when its candidate set (or
        // series pricing) actually changes; otherwise just move the ring
        var key = candidates.map(function (c) { return c.value + (c.available ? '' : '!'); }).join('|');
        if (entry.kind === 'series') {
          key += '$' + candidates.map(function (c) { return priceFor(product, entry.idx, c.value, s.chosen); }).join(',');
        }
        if (key !== entry.key) {
          entry.key = key;
          renderOptionValues(entry, candidates);
        }
        entry.valuesEl.querySelectorAll('[data-value]').forEach(function (btn) {
          btn.classList.toggle('is-selected', btn.dataset.value === s.chosen[entry.opt.name]);
        });
        if (entry.currentEl) entry.currentEl.textContent = s.chosen[entry.opt.name] || '';
      });

      var variant = matchVariant(product, s.chosen);
      var accentUnitPrice = 0;
      var customizationUnitPrice = 0;
      if (s.accentEl) {
        var candidates = variant && variant.available ? accentCandidates(s.accentAddon, product, variant) : [];
        if (s.accent && !candidates.some(function (candidate) {
          return String(candidate.variant.id) === String(s.accent.variant.id);
        })) {
          s.accent = null;
        }
        var accentKey = candidates.map(function (candidate) { return candidate.variant.id; }).join('|');
        if (accentKey !== s.accentKey) {
          s.accentKey = accentKey;
          renderAccentOptions(candidates);
        }
        s.accentEl.hidden = !candidates.length;
        if (s.accentPriceEl) {
          var priceCandidate = s.accent || candidates[0];
          s.accentPriceEl.innerHTML = priceCandidate ? addonPriceHTML(priceCandidate.price, priceCandidate.regularPrice) : '';
        }
        if (s.accentCurrentEl) {
          s.accentCurrentEl.textContent = s.accent && s.accent.color ? s.accent.color : '';
        }
        if (s.accentValuesEl) {
          s.accentValuesEl.querySelectorAll('[data-variant-id]').forEach(function (btn) {
            btn.classList.toggle('is-selected', !!s.accent && String(btn.dataset.variantId) === String(s.accent.variant.id));
          });
        }
        accentUnitPrice = s.accent && s.accent.variant ? Number(s.accent.price || s.accent.variant.price || 0) : 0;
      }
      customizationUnitPrice = syncCustomization(product, variant);

      var img = els.sheetBody.querySelector('[data-sheet-img]');
      var src = modalImageSrc(product, variant, s.chosen, s.accent);
      if (img && src && img.getAttribute('src') !== src) img.src = src;

      var priceEl = els.sheetBody.querySelector('[data-sheet-price]');
      var addBtn = els.sheetBody.querySelector('[data-sheet-add]');
      if (variant && variant.available) {
        var compare = variant.compare_at_price && variant.compare_at_price > variant.price
          ? ' <s>' + money(variant.compare_at_price * s.qty) + '</s>' : '';
        var sheetTotal = (variant.price + accentUnitPrice + customizationUnitPrice) * s.qty;
        priceEl.innerHTML = money(sheetTotal) + compare;
        addBtn.textContent = 'Add to bundle — ' + money(sheetTotal);
        addBtn.disabled = false;
      } else {
        priceEl.textContent = variant ? 'Sold out' : 'Unavailable in this combination';
        addBtn.textContent = variant ? 'Sold out' : 'Unavailable';
        addBtn.disabled = true;
      }
      els.sheetBody.querySelector('[data-sheet-qty]').textContent = s.qty;

      var shipEl = els.sheetBody.querySelector('[data-sheet-ship]');
      if (shipEl) {
        var delay = shipDelay(variant, product);
        if (delay) { shipEl.textContent = delay; shipEl.hidden = false; }
        else { shipEl.textContent = ''; shipEl.hidden = true; }
      }

      panel.scrollTop = keepScroll;
    }

    els.sheet.querySelectorAll('[data-mb-bb-sheet-close]').forEach(function (node) {
      node.addEventListener('click', closeSheet);
    });
    document.addEventListener('keyup', function (e) {
      if (e.key === 'Escape' && sheetState) closeSheet();
    });

    /* ---------- picks ---------- */
    function accentVariantId(accent) {
      return accent && accent.variant ? String(accent.variant.id) : '';
    }

    function addPick(group, product, variant, qty, accent, customization) {
      if (!variant) return;
      var accentId = accentVariantId(accent);
      var customizationKey = customizationSelectionKey(customization);
      var existing = picks.find(function (p) {
        return p.variant.id === variant.id
          && p.groupId === group.id
          && accentVariantId(p.accent) === accentId
          && customizationSelectionKey(p.customization) === customizationKey;
      });
      if (existing) existing.qty += qty;
      else picks.push({
        uid: 'p' + (++uidSeq),
        groupId: group.id,
        product: product,
        variant: variant,
        qty: qty,
        accent: accent || null,
        customization: customization || null
      });

      // gallery shows a high-res rendition (the small variant.image is only for
      // tiles/thumbs); fall back through the available sizes
      var pickImg = (variant && variant.gallery_image) || product.gallery_image ||
        (variant && variant.image) || product.featured_image;
      if (pickImg) showGalleryImage(pickImg);
      update();
    }

    function removePick(uid) {
      picks = picks.filter(function (p) { return p.uid !== uid; });
      if (!picks.length && galleryOriginal) {
        showGalleryImage(galleryOriginal);
      }
      update();
    }

    function changeQty(uid, delta) {
      var pick = picks.find(function (p) { return p.uid === uid; });
      if (!pick) return;
      pick.qty += delta;
      if (pick.qty <= 0) return removePick(uid);
      update();
    }

    function renderPicks() {
      groups.forEach(function (group) {
        var list = root.querySelector('[data-mb-bb-picks="' + group.id + '"]');
        var state = root.querySelector('[data-mb-bb-group-state="' + group.id + '"]');
        if (!list) return;
        list.innerHTML = '';
        var groupPicks = picks.filter(function (p) { return p.groupId === group.id; });

        groupPicks.forEach(function (pick) {
          var li = el('li', 'mb-bb__pick');
          var vTitle = pick.variant.title === 'Default Title' ? '' : pick.variant.title;
          var img = pick.variant.image || pick.product.featured_image;
          var accentTitle = pick.accent ? '+ ' + pick.accent.color + ' color accent' : '';
          var customizationTitle = pick.customization
            ? '+ ' + (pick.customization.summary || pick.customization.title || 'Personalization')
            : '';
          li.innerHTML =
            (img ? '<img src="' + escapeHtml(img) + '" alt="">' : '') +
            '<div class="mb-bb__pick-info">' +
            '<p class="mb-bb__pick-name">' + escapeHtml(displayName(pick.product)) + '</p>' +
            (vTitle ? '<p class="mb-bb__pick-variant">' + escapeHtml(vTitle) + '</p>' : '') +
            (accentTitle ? '<p class="mb-bb__pick-variant mb-bb__pick-accent">' + escapeHtml(accentTitle) + '</p>' : '') +
            (customizationTitle ? '<p class="mb-bb__pick-variant mb-bb__pick-customization">' + escapeHtml(customizationTitle) + '</p>' : '') +
            '</div>' +
            '<div class="mb-bb__pick-qty">' +
            '<button type="button" data-pick-minus aria-label="Decrease">&minus;</button>' +
            '<span>' + pick.qty + '</span>' +
            '<button type="button" data-pick-plus aria-label="Increase">+</button>' +
            '</div>' +
            '<span class="mb-bb__pick-price">' + money(pickLinePrice(pick)) + '</span>' +
            '<button type="button" class="mb-bb__pick-remove" data-pick-remove aria-label="Remove">&times;</button>';
          li.querySelector('[data-pick-minus]').addEventListener('click', function () { changeQty(pick.uid, -1); });
          li.querySelector('[data-pick-plus]').addEventListener('click', function () { changeQty(pick.uid, 1); });
          li.querySelector('[data-pick-remove]').addEventListener('click', function () { removePick(pick.uid); });
          list.appendChild(li);
        });

        if (state) {
          var count = groupPicks.reduce(function (n, p) { return n + p.qty; }, 0);
          state.textContent = count ? count + ' selected' : '';
        }

        group.products.forEach(function (product) {
          if (!product) return;
          var tile = els.groups.querySelector('.mb-bb__tile[data-product-id="' + product.id + '"]');
          if (!tile) return;
          var badge = tile.querySelector('[data-tile-badge]');
          var n = groupPicks.filter(function (p) { return p.product.id === product.id; })
            .reduce(function (a, p) { return a + p.qty; }, 0);
          tile.classList.toggle('is-picked', n > 0);
          if (badge) {
            badge.hidden = !n;
            badge.textContent = n ? '✓ ' + n : '';
          }
        });
      });
    }

    /* ---------- meter / summary / cta ---------- */

    function update() {
      renderPicks();

      var count = totalQty();
      var subtotal = picks.reduce(function (n, p) { return n + p.variant.price * p.qty; }, 0);
      var addonSubtotal = picks.reduce(function (n, p) { return n + accentPickPrice(p) + customizationPickPrice(p); }, 0);
      var tier = activeTier(count);
      var upcoming = nextTier(count);
      var discount = tier ? Math.round(subtotal * tier.percent / 100) : 0;
      var total = subtotal - discount + addonSubtotal;

      var sortedCounts = tiers.map(function (t) { return t.count; });
      els.tierTiles.forEach(function (tile) {
        var tileCount = Number(tile.dataset.mbBbTier);
        tile.classList.toggle('is-reached', count >= tileCount);
        tile.classList.toggle('is-current', !!tier && tier.count === tileCount);
        var fill = tile.querySelector('[data-mb-bb-tier-fill]');
        if (fill) {
          // each tile's strip tracks progress from the previous tier to this one
          var idx = sortedCounts.indexOf(tileCount);
          var prev = idx > 0 ? sortedCounts[idx - 1] : 0;
          var pct = tileCount === prev ? 100 : (count - prev) / (tileCount - prev) * 100;
          fill.style.width = Math.max(0, Math.min(100, pct)) + '%';
        }
      });

      els.summary.hidden = !count;
      if (count) {
        els.lines.innerHTML = picks.map(function (p) {
          var vTitle = p.variant.title === 'Default Title' ? '' : ' · ' + p.variant.title;
          var accentTitle = p.accent ? ' + ' + p.accent.color + ' accent' : '';
          return '<li><span>' + p.qty + '× ' + escapeHtml(displayName(p.product)) + escapeHtml(vTitle) + escapeHtml(accentTitle) + '</span><span>' + money(pickLinePrice(p)) + '</span></li>';
        }).join('');
        els.subtotal.textContent = money(subtotal + addonSubtotal);
        els.discountRow.hidden = !discount;
        if (discount) {
          els.discountLabel.textContent = 'Bundle discount (' + tier.percent + '%)';
          els.discount.textContent = '−' + money(discount);
        }
        els.total.textContent = money(total);
        els.note.hidden = !discount;
      }

      var atcEnabled = count > 0;
      els.atc.disabled = !atcEnabled;
      els.atcLabel.textContent = atcEnabled
        ? 'Add ' + count + ' item' + (count > 1 ? 's' : '') + ' to cart'
        : 'Select your first item';

      els.stickyAtc.disabled = !atcEnabled;
      els.stickyCount.hidden = !count;
      els.stickyCount.textContent = count ? '×' + count : '';
      els.stickyLabel.textContent = count
        ? count + ' item' + (count > 1 ? 's' : '') + (tier ? ' · ' + tier.percent + '% OFF at checkout' : '')
        : 'Select your items';
      els.stickyTotal.hidden = !count;
      els.stickyTotal.textContent = count ? money(total) : '';
      els.stickyCompare.hidden = !discount;
      els.stickyCompare.textContent = discount ? money(subtotal) : '';
      els.stickySave.hidden = !discount;
      els.stickySave.textContent = discount ? 'Save ' + money(discount) : '';
    }

    /* ---------- errors ---------- */
    var errorTimer = null;
    function flashError(message) {
      els.error.textContent = message;
      els.error.hidden = false;
      clearTimeout(errorTimer);
      errorTimer = setTimeout(function () { els.error.hidden = true; }, 4000);
    }

    /* ---------- add to cart ---------- */
    var adding = false;
    function cartUpdateUrl() {
      var base = (window.routes && window.routes.cart_update_url) || '/cart/update';
      return base.endsWith('.js') ? base : base + '.js';
    }

    function clearCartDiscount() {
      return fetch(cartUpdateUrl(), {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ discount: '' })
      }).then(function (r) {
        if (!r.ok) throw new Error('Unable to prepare cart for bundle savings');
        return r.json();
      });
    }

    function addBundleToCart() {
      if (adding || !picks.length) return;
      adding = true;
      els.atc.classList.add('is-loading');

      var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      var cartItems = [];
      var relationshipPlan = planBundleRelationships(picks);
      if (!relationshipPlan) {
        adding = false;
        els.atc.classList.remove('is-loading');
        flashError('Your bundle could not be added safely. Please refresh and try again.');
        return;
      }
      picks.forEach(function (p, pickIndex) {
        var childLinkIndex = 0;
        var primaryProperties = {
          _mb_link: relationshipPlan.primaryLinks[pickIndex]
        };
        cartItems.push({
          id: p.variant.id,
          quantity: p.qty,
          properties: primaryProperties
        });
        if (p.accent && p.accent.variant) {
          var accentProperties = {
            _mb_link: relationshipPlan.childLinks[pickIndex][childLinkIndex]
          };
          childLinkIndex += 1;
          cartItems.push({
            id: p.accent.variant.id,
            quantity: p.qty,
            properties: accentProperties
          });
        }
        if (p.customization && p.customization.variant) {
          var customizationProperties = relationshipContract.fulfillmentProperties({
            engravingText: (p.customization.properties || {})['Engrave Text'],
            parentSku: p.variant.sku || '',
            link: relationshipPlan.childLinks[pickIndex][childLinkIndex]
          });
          childLinkIndex += 1;
          cartItems.push({
            id: p.customization.variant.id,
            quantity: p.qty,
            properties: customizationProperties
          });
        }
      });
      var body = {
        items: cartItems.slice().reverse()
      };
      if (cart && cart.getSectionsToRender) {
        body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
      }

      clearCartDiscount()
        .then(function () {
          return fetch(config.cartAddUrl || '/cart/add.js', {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify(body)
          });
        })
        .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.data && (res.data.description || res.data.message) || 'Unable to add to cart');
          if (cart && cart.renderContents && res.data.sections) {
            cart.renderContents(res.data);
          }
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: res.data }));
          picks = [];
          if (els.gallery && galleryOriginal) els.gallery.src = galleryOriginal;
            update();
        })
        .catch(function (err) {
          flashError(err.message || 'Unable to add to cart. Please try again.');
        })
        .finally(function () {
          adding = false;
          els.atc.classList.remove('is-loading');
        });
    }

    els.atc.addEventListener('click', addBundleToCart);
    els.stickyAtc.addEventListener('click', addBundleToCart);

    // PDP sticky-ATC setup: the bar shows whenever the in-flow add-to-cart
    // button is off-screen — including at page load, where the bundle CTA sits
    // far below the groups. Mobile keeps it always visible via CSS, like the PDP.
    if ('IntersectionObserver' in window) {
      var ctaObserver = new IntersectionObserver(function (entries) {
        var inView = entries[0].isIntersecting;
        var stuck = !inView;
        els.sticky.classList.toggle('is-visible', stuck);
        els.sticky.setAttribute('aria-hidden', String(inView));
        document.documentElement.classList.toggle('mb-sticky-atc-on', stuck);
      }, { threshold: 0.05 });
      ctaObserver.observe(els.atc);
    } else {
      els.sticky.classList.add('is-visible');
      els.sticky.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('mb-sticky-atc-on');
    }

    /* ---------- desktop gallery: main image / video swap via thumbs ---------- */
    // reset the main area to a still image (used by thumb image clicks and by
    // product picks, which always preview a product photo)
    function showGalleryImage(src) {
      if (els.galleryVideo) {
        els.galleryVideo.pause();
        els.galleryVideo.hidden = true;
      }
      if (els.gallery) {
        els.gallery.hidden = false;
        if (src) { els.gallery.src = src; els.gallery.srcset = ''; }
      }
    }

    function showGalleryVideo(src, poster) {
      if (!els.galleryVideo) return;
      if (els.gallery) els.gallery.hidden = true;
      els.galleryVideo.hidden = false;
      if (poster) els.galleryVideo.poster = poster;
      if (src && els.galleryVideo.getAttribute('src') !== src) {
        els.galleryVideo.src = src;
      }
      var p = els.galleryVideo.play();
      if (p && p.catch) p.catch(function () {});
    }

    root.querySelectorAll('[data-mb-bb-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (thumb.dataset.mbBbThumbType === 'video' && thumb.dataset.mbBbThumbVideo) {
          showGalleryVideo(thumb.dataset.mbBbThumbVideo, thumb.dataset.mbBbThumbPoster);
        } else {
          showGalleryImage(thumb.dataset.mbBbThumbImage);
        }
        root.querySelectorAll('[data-mb-bb-thumb]').forEach(function (t) {
          t.classList.toggle('is-active', t === thumb);
        });
      });
    });

    /* ---------- desktop thumb-rail scroll arrows (PDP .mb-clean-gallery__scroll) ---------- */
    var thumbRail = root.querySelector('[data-mb-bb-thumbs]');
    var thumbScrollUp = root.querySelector('[data-mb-bb-thumb-scroll="up"]');
    var thumbScrollDown = root.querySelector('[data-mb-bb-thumb-scroll="down"]');
    function updateThumbScrollArrows() {
      if (!thumbRail) return;
      var canScroll = thumbRail.scrollHeight - thumbRail.clientHeight > 2;
      var atTop = thumbRail.scrollTop <= 2;
      var atBottom = thumbRail.scrollTop + thumbRail.clientHeight >= thumbRail.scrollHeight - 2;
      if (thumbScrollUp) thumbScrollUp.classList.toggle('is-hidden', !canScroll || atTop);
      if (thumbScrollDown) thumbScrollDown.classList.toggle('is-hidden', !canScroll || atBottom);
    }
    function scrollThumbRail(dir) {
      if (!thumbRail) return;
      var dist = Math.max(thumbRail.clientHeight * 0.8, 100);
      thumbRail.scrollBy({ top: dir * dist, behavior: prefersReducedMotion() ? 'auto' : 'smooth' });
    }
    if (thumbRail) {
      if (thumbScrollUp) thumbScrollUp.addEventListener('click', function () { scrollThumbRail(-1); });
      if (thumbScrollDown) thumbScrollDown.addEventListener('click', function () { scrollThumbRail(1); });
      thumbRail.addEventListener('scroll', function () {
        if (document.hidden) { updateThumbScrollArrows(); return; }
        window.requestAnimationFrame(updateThumbScrollArrows);
      }, { passive: true });
      window.addEventListener('resize', updateThumbScrollArrows);
      updateThumbScrollArrows();
    }

    /* ---------- media lightbox (closer look; reuses PDP .mb-clean-lightbox CSS) ---------- */
    var lightbox = root.querySelector('[data-mb-bb-lightbox]');
    var lightboxTrack = root.querySelector('[data-mb-bb-lightbox-track]');
    var lightboxCount = root.querySelector('[data-mb-bb-lightbox-count]');
    var lightboxPrev = root.querySelector('[data-mb-bb-lightbox-prev]');
    var lightboxNext = root.querySelector('[data-mb-bb-lightbox-next]');
    var lightboxOpener = root.querySelector('[data-mb-bb-lightbox-open]');
    var bbThumbs = Array.prototype.slice.call(root.querySelectorAll('[data-mb-bb-thumb]'));
    var lbIndex = 0;
    var lbProgrammatic = false;
    var lbScrollTimer = null;
    var lbScrollRaf = null;

    function buildLightboxSlide(thumb) {
      var slide = document.createElement('div');
      slide.className = 'mb-clean-lightbox__slide';
      if (thumb.dataset.mbBbThumbType === 'video' && thumb.dataset.mbBbThumbVideo) {
        var video = document.createElement('video');
        video.controls = true;
        video.loop = true;
        video.muted = true;
        video.playsInline = true;
        video.preload = 'metadata';
        if (thumb.dataset.mbBbThumbPoster) video.poster = thumb.dataset.mbBbThumbPoster;
        var src = document.createElement('source');
        src.src = thumb.dataset.mbBbThumbVideo;
        src.type = 'video/mp4';
        video.appendChild(src);
        slide.appendChild(video);
      } else {
        var img = document.createElement('img');
        img.src = thumb.dataset.mbBbThumbImage || '';
        img.alt = '';
        img.loading = 'lazy';
        img.decoding = 'async';
        slide.appendChild(img);
      }
      return slide;
    }

    function syncLightbox(index, immediate) {
      if (!lightboxTrack) return;
      var slides = Array.prototype.slice.call(lightboxTrack.children);
      if (!slides.length) return;
      lbIndex = Math.max(0, Math.min(slides.length - 1, index));
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === lbIndex);
        slide.querySelectorAll('video').forEach(function (v) {
          if (i === lbIndex) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
          else v.pause();
        });
      });
      if (lightboxCount) lightboxCount.textContent = (lbIndex + 1) + ' / ' + slides.length;
      if (lightboxPrev) lightboxPrev.disabled = lbIndex === 0;
      if (lightboxNext) lightboxNext.disabled = lbIndex === slides.length - 1;
      window.clearTimeout(lbScrollTimer);
      lbProgrammatic = true;
      lbScrollTimer = window.setTimeout(function () { lbProgrammatic = false; }, immediate ? 80 : 420);
      try {
        lightboxTrack.scrollTo({ left: lbIndex * lightboxTrack.clientWidth, behavior: immediate || prefersReducedMotion() ? 'auto' : 'smooth' });
      } catch (e) {
        lightboxTrack.scrollLeft = lbIndex * lightboxTrack.clientWidth;
      }
    }

    function lightboxFromScroll() {
      if (!lightbox || lightbox.hidden || !lightboxTrack || lbProgrammatic) return;
      window.cancelAnimationFrame(lbScrollRaf);
      lbScrollRaf = window.requestAnimationFrame(function () {
        var width = lightboxTrack.clientWidth || 1;
        var index = Math.max(0, Math.min(lightboxTrack.children.length - 1, Math.round(lightboxTrack.scrollLeft / width)));
        if (index !== lbIndex) syncLightbox(index, true);
      });
    }

    function openLightbox() {
      if (!lightbox || !lightboxTrack || !bbThumbs.length) return;
      var activeThumb = root.querySelector('[data-mb-bb-thumb].is-active');
      var startIndex = activeThumb ? bbThumbs.indexOf(activeThumb) : 0;
      if (startIndex < 0) startIndex = 0;
      lightboxTrack.replaceChildren.apply(lightboxTrack, bbThumbs.map(buildLightboxSlide));
      lightbox.hidden = false;
      lightbox.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('mb-clean-lightbox-open');
      // sync synchronously (rAF is suspended on hidden tabs); reading
      // clientWidth here forces the layout the scroll position needs
      syncLightbox(startIndex, true);
      var closeBtn = lightbox.querySelector('[data-mb-bb-lightbox-close]');
      if (closeBtn && closeBtn.focus) closeBtn.focus({ preventScroll: true });
    }

    function closeLightbox() {
      if (!lightbox) return;
      lightbox.setAttribute('aria-hidden', 'true');
      lightbox.hidden = true;
      document.documentElement.classList.remove('mb-clean-lightbox-open');
      if (lightboxTrack) lightboxTrack.querySelectorAll('video').forEach(function (v) { v.pause(); });
      if (lightboxOpener && lightboxOpener.focus) lightboxOpener.focus({ preventScroll: true });
    }

    if (lightbox && lightboxOpener) {
      // a tap opens; a swipe on the mobile track scrolls (no click fires)
      lightboxOpener.addEventListener('click', openLightbox);
      lightboxOpener.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openLightbox(); }
      });
      root.querySelectorAll('[data-mb-bb-lightbox-close]').forEach(function (n) {
        n.addEventListener('click', closeLightbox);
      });
      if (lightboxPrev) lightboxPrev.addEventListener('click', function () { syncLightbox(lbIndex - 1); });
      if (lightboxNext) lightboxNext.addEventListener('click', function () { syncLightbox(lbIndex + 1); });
      if (lightboxTrack) lightboxTrack.addEventListener('scroll', lightboxFromScroll, { passive: true });
      document.addEventListener('keydown', function (e) {
        if (lightbox.hidden) return;
        if (e.key === 'Escape') closeLightbox();
        else if (e.key === 'ArrowLeft') syncLightbox(lbIndex - 1);
        else if (e.key === 'ArrowRight') syncLightbox(lbIndex + 1);
      });
    }

    /* ---------- mobile gallery: pin + shrink on scroll (PDP DNA) ---------- */
    var galleryWrap = root.querySelector('.mb-bb__gallery');
    var galleryMain = root.querySelector('[data-mb-bb-gallery]');
    var galleryPanel = root.querySelector('.mb-bb__panel');
    var mgp = { progress: 0, target: 0, raf: null, measureRaf: null };

    function isMobileGallery() {
      return window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
    }

    function prefersReducedMotion() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function setupMobileTopBarAutohide() {
      if (document.documentElement.dataset.mbBbBarController === 'true') return;
      var barEls = ['.announcement-bar-section', '.section-header'].map(function (selector) {
        return document.querySelector(selector);
      }).filter(Boolean);
      if (!barEls.length) return;
      document.documentElement.dataset.mbBbBarController = 'true';

      var ease = 'transform 240ms cubic-bezier(0.22, 1, 0.36, 1)';
      var lastY = window.scrollY || 0;
      var offset = 0;
      var barH = 0;

      function measure() {
        barH = barEls.reduce(function (height, el) {
          return height + (el.offsetHeight || 0);
        }, 0) || 108;
      }

      function applyOffset(next, animate) {
        barEls.forEach(function (el) {
          el.style.setProperty('transition', animate ? ease : 'none', 'important');
          if (next <= 0) {
            el.style.removeProperty('transform');
          } else {
            el.style.setProperty('transform', 'translate3d(0, -' + next + 'px, 0)', 'important');
          }
        });
      }

      function reset() {
        if (offset !== 0) {
          offset = 0;
          applyOffset(0, false);
        }
        lastY = window.scrollY || 0;
      }

      function onScroll() {
        if (!isMobileGallery() || prefersReducedMotion()) {
          reset();
          return;
        }
        var y = Math.max(0, window.scrollY || 0);
        var delta = y - lastY;
        lastY = y;
        var next = offset;
        if (y <= 0) next = 0;
        else if (delta > 2) next = barH;
        else if (delta < -2) next = 0;
        if (next === offset) return;
        offset = next;
        applyOffset(next, true);
      }

      measure();
      window.addEventListener('resize', function () {
        measure();
        if (!isMobileGallery() || prefersReducedMotion()) reset();
      });
      window.addEventListener('scroll', onScroll, { passive: true });
    }

    setupMobileTopBarAutohide();

    function setGalleryProgress(progress) {
      var next = Math.max(0, Math.min(1, progress));
      mgp.progress = next;
      root.classList.toggle('is-mobile-gallery-compact', next > 0.02);
      root.style.setProperty('--mb-bb-gallery-progress', next.toFixed(3));
    }

    function animateGalleryProgress() {
      mgp.raf = null;
      if (prefersReducedMotion()) {
        setGalleryProgress(mgp.target);
        return;
      }
      var delta = mgp.target - mgp.progress;
      if (Math.abs(delta) < 0.004) {
        setGalleryProgress(mgp.target);
        return;
      }
      setGalleryProgress(mgp.progress + (delta * 0.32));
      mgp.raf = window.requestAnimationFrame(animateGalleryProgress);
    }

    function updateGalleryPinState() {
      mgp.measureRaf = null;
      if (!galleryWrap || !galleryMain) return;
      if (!isMobileGallery()) {
        root.classList.remove('is-mobile-gallery-compact');
        root.style.removeProperty('--mb-bb-gallery-progress');
        mgp.progress = 0;
        mgp.target = 0;
        return;
      }

      var rem = parseFloat(window.getComputedStyle(document.documentElement).fontSize) || 10;
      var galleryStyles = window.getComputedStyle(galleryWrap);
      var fullHeight = Math.min(window.innerWidth - (2.4 * rem), 39 * rem);
      var compactHeight = Math.max(0, (window.innerWidth * 0.55) - (1.32 * rem));
      var shrinkRange = Math.max(1, fullHeight - compactHeight);
      var galleryTop = parseFloat(galleryStyles.top) || galleryMain.getBoundingClientRect().top;
      var panelTop = galleryPanel ? galleryPanel.getBoundingClientRect().top : Number.POSITIVE_INFINITY;
      var collisionGap = 16;
      var collisionProgress = Math.max(0, Math.min(1, (fullHeight - (panelTop - galleryTop - collisionGap)) / shrinkRange));
      var start = root.offsetTop + 12;
      var distance = 180;
      var scrollProgress = Math.max(0, Math.min(1, (window.scrollY - start) / distance));
      mgp.target = Math.max(scrollProgress, collisionProgress);
      if (document.hidden) {
        // rAF is suspended on hidden pages; land on the target so the
        // gallery is already correct when the tab becomes visible
        setGalleryProgress(mgp.target);
      } else if (!mgp.raf) {
        mgp.raf = window.requestAnimationFrame(animateGalleryProgress);
      }
    }

    function requestGalleryPinUpdate() {
      if (document.hidden) {
        updateGalleryPinState();
        return;
      }
      if (mgp.measureRaf) return;
      mgp.measureRaf = window.requestAnimationFrame(updateGalleryPinState);
    }

    window.addEventListener('resize', requestGalleryPinUpdate);
    window.addEventListener('scroll', requestGalleryPinUpdate, { passive: true });
    requestGalleryPinUpdate();

    /* ---------- mobile gallery: swipe track dots ---------- */
    var galleryTrack = root.querySelector('[data-mb-bb-track]');
    var galleryDots = Array.prototype.slice.call(root.querySelectorAll('[data-mb-bb-dots] span'));
    // mobile carousel: only the slide in view plays; its mp4 is lazy-loaded
    // the first time it becomes active (preload="none" until then)
    var slideVideos = Array.prototype.slice.call(root.querySelectorAll('.mb-bb__gallery-slide-video'));
    function playSlideVideoAt(index) {
      root.querySelectorAll('.mb-bb__gallery-slide').forEach(function (slide, i) {
        var video = slide.querySelector('.mb-bb__gallery-slide-video');
        if (!video) return;
        if (i === index) {
          var src = video.dataset.mbBbVideoSrc;
          if (src && !video.getAttribute('src')) video.src = src;
          // reveal the video only once it's actually playing; until then the
          // poster img beneath stays visible (no blank frame)
          if (!video.dataset.mbBbPlayingBound) {
            video.dataset.mbBbPlayingBound = '1';
            video.addEventListener('playing', function () {
              video.classList.add('is-playing');
            });
          }
          var p = video.play();
          if (p && p.catch) p.catch(function () {});
        } else if (!video.paused) {
          video.pause();
          video.classList.remove('is-playing');
        }
      });
    }

    if (galleryTrack && galleryDots.length) {
      var dotRaf = null;
      var lastSlideIndex = -1;
      var syncGalleryDots = function () {
        dotRaf = null;
        var width = galleryTrack.clientWidth || 1;
        var index = Math.max(0, Math.min(galleryDots.length - 1, Math.round(galleryTrack.scrollLeft / width)));
        galleryDots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === index);
        });
        if (index !== lastSlideIndex) {
          lastSlideIndex = index;
          if (slideVideos.length) playSlideVideoAt(index);
        }
      };
      galleryTrack.addEventListener('scroll', function () {
        if (document.hidden) {
          syncGalleryDots();
          return;
        }
        if (dotRaf) return;
        dotRaf = window.requestAnimationFrame(syncGalleryDots);
      }, { passive: true });
    }

    /* ---------- boot ---------- */
    renderGroups();
    update();
  }

  function boot() {
    document.querySelectorAll('[data-mb-bundle-builder]').forEach(initBundleBuilder);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
